import React from 'react'
import platform from '../../assets/images/mains/designer.svg';

const PlatformLanding = () => {
  return (
    <div className='hero-container custom-hero-container container-sm mb-5'>
        <div className=' hero-row custom-hero-row row m-0 w-100 h-100'>
            <div className='col-12 col-sm-6 heroText-container flex'>
                <div className='heroTitle w-100 mt-5'>
                    <h2  x-intersect="$el.classList.add('fadeInUp-parallax')">CausalFunnel Platform</h2>
                </div>
                <div className='heroDesc w-100 my-4'>
                    <p  x-intersect="$el.classList.add('fadeInUp-parallax')">Predicting Buying Intent using Cookie-agnostic AI.</p>
                </div>
            </div>
            <div className='col-12 col-sm-6 mt-5 mt-sm-0'>
                <div className='hero-img-container-custom'>
                    <img className='img-fluid' src={platform} alt="platform"  x-intersect="$el.classList.add('scale-parallax')"/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default PlatformLanding